import { render, staticRenderFns } from "./StudyParticipants.vue?vue&type=template&id=4010a4b6&"
import script from "./StudyParticipants.vue?vue&type=script&lang=js&"
export * from "./StudyParticipants.vue?vue&type=script&lang=js&"
import style0 from "./StudyParticipants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports